import { Controller, useFormContext } from "react-hook-form";
import { Building2, UserCog } from "lucide-react";

import { FormSubBlock } from "@/components/campos-formulario/form-shell/FormSubBlock";
import { CargosField } from "@/pages/admin/aprovacoes/components/CargosField";
import { cargoLabel, cargoOptions } from "@/pages/admin/aprovacoes/aprovacao-config-options";
import { ComunicadoSistemaFormData } from "@/validations/comunicado-sistema-validation-schema";
import { areaLabel, areaOptions } from "../comunicado-segmentacao-options";

/**
 * Passo "Configuração" (segmentação, §2.2): cargos e/ou áreas alvo. Vazios os
 * dois = comunicado global, visível a todos. Reusa o `CargosField` das
 * aprovações (generalizado por props) para os dois eixos.
 */
export function SegmentacaoSection() {
  const { control } = useFormContext<ComunicadoSistemaFormData>();

  return (
    <FormSubBlock title="Público-alvo">
      <div className="space-y-5">
        <p className="text-sm text-muted-foreground">
          Deixe os dois vazios para o comunicado aparecer a todos.
        </p>

        <Controller
          name="cargos"
          control={control}
          render={({ field, fieldState }) => (
            <CargosField
              value={field.value ?? []}
              onChange={field.onChange}
              error={fieldState.error?.message}
              options={cargoOptions}
              labelResolver={cargoLabel}
              title="Cargos"
              icon={<UserCog className="size-3.5" />}
              searchPlaceholder="Buscar cargo..."
              emptyTitle="Nenhum cargo ainda"
              emptyDescription="Visível a todos os cargos, a menos que adicione um aqui."
            />
          )}
        />

        <Controller
          name="areas"
          control={control}
          render={({ field, fieldState }) => (
            <CargosField
              value={field.value ?? []}
              onChange={field.onChange}
              error={fieldState.error?.message}
              options={areaOptions}
              labelResolver={areaLabel}
              title="Áreas"
              icon={<Building2 className="size-3.5" />}
              searchPlaceholder="Buscar área..."
              emptyTitle="Nenhuma área ainda"
              emptyDescription="Visível a todas as áreas, a menos que adicione uma aqui."
            />
          )}
        />
      </div>
    </FormSubBlock>
  );
}
